import produce from 'immer';
import { AnyAction } from 'redux';
import { ApiError } from '@common-types/api';
import {
    AboutData,
    BooztersData,
    ClubData,
    MyClubData,
    ClubUpgradeData,
    ClubSubscriptionPaymentInfoData,
    ClubSubscriptionInfoData,
    ClubSubscriptionInvoicesData,
} from '@common/Dashboard/Club/types';
import {
    RESET_BOOZTERS_DATA,
    RESET_CLUB_DATA,
    RESET_MY_CLUB_DATA,
    SET_BOOZTERS,
    SET_BOOZTERS_ERROR,
    SET_CLUB,
    SET_CLUB_ABOUT_DATA,
    SET_CLUB_ABOUT_ERROR,
    SET_CLUB_ABOUT_POINTS_DATA,
    SET_CLUB_ABOUT_POINTS_ERROR,
    SET_CLUB_ERROR,
    SET_MY_CLUB,
    SET_MY_CLUB_ERROR,
    SET_CLUB_UPGRADE_DATA,
    SET_CLUB_UPGRADE_ERROR,
    SET_CLUB_SUBSCRIPTION_PAYMENT_INFO_DATA,
    SET_CLUB_SUBSCRIPTION_PAYMENT_INFO_ERROR,
    SET_CLUB_SUBSCRIPTION_INFO_DATA,
    SET_CLUB_SUBSCRIPTION_INFO_ERROR,
    SET_CLUB_SUBSCRIPTION_INVOICES_DATA,
    SET_CLUB_SUBSCRIPTION_INVOICES_ERROR,
    UPDATE_CLUB_SUBSCRIPTION_INVOICES_DATA,
} from '@common/Dashboard/constants';

interface ClubState<T> {
    data: T | null;
    error: ApiError | null;
}

interface DashboardClubState {
    club: ClubState<ClubData>;
    myClub: ClubState<MyClubData>;
    boozters: ClubState<BooztersData>;
    aboutClub: ClubState<AboutData>;
    aboutPoints: ClubState<any>;
    clubUpgrade: ClubState<ClubUpgradeData>;
    clubSubscriptionPaymentInfo: ClubState<ClubSubscriptionPaymentInfoData>;
    clubSubscriptionInfo: ClubState<ClubSubscriptionInfoData>;
    clubSubscriptionInvoices: ClubState<ClubSubscriptionInvoicesData>;
}

const initialState = {
    club: {
        data: null,
        error: null,
    },
    myClub: {
        data: null,
        error: null,
    },
    boozters: {
        data: null,
        error: null,
    },
    aboutClub: {
        data: null,
        error: null,
    },
    aboutPoints: {
        data: null,
        error: null,
    },
    clubUpgrade: {
        data: null,
        error: null,
    },
    clubSubscriptionPaymentInfo: {
        data: null,
        error: null,
    },
    clubSubscriptionInfo: {
        data: null,
        error: null,
    },
    clubSubscriptionInvoices: {
        data: null,
        error: null,
    },
};

export const dashboardClub = produce((
    state: DashboardClubState,
    action: AnyAction = { type: null },
) => {
    const { type, payload } = action;

    switch (type) {
        case SET_CLUB: {
            state.club = {
                data: payload,
                error: null,
            };

            break;
        }

        case SET_CLUB_ERROR: {
            state.club.error = payload;

            break;
        }

        case SET_MY_CLUB: {
            state.myClub = {
                data: payload,
                error: null,
            };

            break;
        }

        case SET_MY_CLUB_ERROR: {
            state.myClub.error = payload;

            break;
        }

        case SET_BOOZTERS: {
            state.boozters = {
                data: payload,
                error: null,
            };

            break;
        }

        case SET_BOOZTERS_ERROR: {
            state.boozters.error = payload;

            break;
        }

        case RESET_CLUB_DATA: {
            state.club = initialState.club;
            break;
        }

        case RESET_MY_CLUB_DATA: {
            state.myClub = initialState.myClub;
            break;
        }

        case RESET_BOOZTERS_DATA: {
            state.boozters = initialState.boozters;
            break;
        }

        case SET_CLUB_ABOUT_DATA: {
            state.aboutClub.data = payload;
            break;
        }

        case SET_CLUB_ABOUT_ERROR: {
            state.aboutClub.error = payload;
            break;
        }

        case SET_CLUB_ABOUT_POINTS_DATA: {
            state.aboutPoints.data = payload;
            break;
        }

        case SET_CLUB_ABOUT_POINTS_ERROR: {
            state.aboutPoints.error = payload;
            break;
        }

        case SET_CLUB_UPGRADE_DATA: {
            state.clubUpgrade.data = payload;
            break;
        }

        case SET_CLUB_UPGRADE_ERROR: {
            state.clubUpgrade.error = payload;
            break;
        }

        case SET_CLUB_SUBSCRIPTION_PAYMENT_INFO_DATA: {
            state.clubSubscriptionPaymentInfo.data = payload;
            break;
        }

        case SET_CLUB_SUBSCRIPTION_PAYMENT_INFO_ERROR: {
            state.clubSubscriptionPaymentInfo.error = payload;
            break;
        }

        case SET_CLUB_SUBSCRIPTION_INFO_DATA: {
            state.clubSubscriptionInfo.data = payload;
            break;
        }

        case SET_CLUB_SUBSCRIPTION_INFO_ERROR: {
            state.clubSubscriptionInfo.error = payload;
            break;
        }

        case SET_CLUB_SUBSCRIPTION_INVOICES_DATA: {
            state.clubSubscriptionInvoices.data = payload;
            break;
        }

        case SET_CLUB_SUBSCRIPTION_INVOICES_ERROR: {
            state.clubSubscriptionInvoices.error = payload;
            break;
        }

        case UPDATE_CLUB_SUBSCRIPTION_INVOICES_DATA: {
            state.clubSubscriptionInvoices.data = {
                ...payload,
                invoices: [
                    ...(state.clubSubscriptionInvoices.data?.invoices || []),
                    ...payload.invoices,
                ],
            };

            break;
        }

        // skip default
    }
}, initialState);

export default dashboardClub;
